import _ from "lodash";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import UIModal from "UIComponents/UIModal";

import classes from "./LEIntoUnitImport.scss";
import Header from "./Header";
import Footer from "./Footer";
import GradeList from "./GradeList";
import UnitSelectionPage from "./UnitSelectionPage";

// modules
import {
  resetState,
  updateSelectedUnit,
} from "AppComponents/LEIntoUnitImport/modules/Module";
import { setGlobalHeaderVisibility } from "Login/modules/LoginModule";

const getModalBody = ({ isCurriculumSelectionDisabled, academicYears }) => {
  return (
    <div className={classes.bodyContainer}>
      <div className={classes.gradeListContainer}>
        <GradeList
          isCurriculumSelectionDisabled={isCurriculumSelectionDisabled}
        />
      </div>
      <div className={classes.unitListContainer}>
        <UnitSelectionPage academicYears={academicYears} />
      </div>
    </div>
  );
};

const LEIntoUnitImport = ({
  headerText,
  closeModal,
  handleSubmit,
  isCurriculumSelectionDisabled,
  academicYears,
  setGlobalHeaderVisibility,
  isGlobalHeaderVisible,
  updateSelectedUnit,
}) => {
  useEffect(() => {
    setGlobalHeaderVisibility(false);
    return () => {
      updateSelectedUnit({});
      // change it to the old global header visibility status
      setGlobalHeaderVisibility(isGlobalHeaderVisible);
    };
  }, []);

  return (
    <UIModal isOpen={true} isFullScreen={true}>
      <div className={classes.modalContainer}>
        <Header closeModal={closeModal} headerText={headerText} />
        <div className={classes.modalBody}>
          {getModalBody({ isCurriculumSelectionDisabled, academicYears })}
        </div>
        <Footer closeModal={closeModal} onImportHandler={handleSubmit} />
      </div>
    </UIModal>
  );
};

LEIntoUnitImport.defaultProps = {
  headerText: "",
  closeModal: _.noop,
  handleSubmit: _.noop,
  isCurriculumSelectionDisabled: false,
  academicYears: [],
};

const mapStateToProps = state => {
  const isGlobalHeaderVisible = _.get(
    state,
    "login.globalHeader.isVisible",
    false
  );

  return { isGlobalHeaderVisible };
};

const mapActionCreators = {
  resetState,
  setGlobalHeaderVisibility,
  updateSelectedUnit,
};

export default connect(mapStateToProps, mapActionCreators)(LEIntoUnitImport);
